export const GROUP_STAFF = 'staff';
export const GROUP_OWNER = 'owner';



// WEBPACK FOOTER //
// ./src/data/userGroups.js